// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"Tooltip_tooltipWrapper__3HFJS","tooltip":"Tooltip_tooltip__BQsW8","adjustLeft":"Tooltip_adjustLeft__1uxsh","adjustRight":"Tooltip_adjustRight__hTRPi"};